export const fr = {
    _newcomposition: "Nouvelle Composition",
    _playvideo: "Lire la Vidéo",
    _stopvideo: "Arrêter la Vidéo",
    _exportvideo: "Exporter la Vidéo",
    _videos: "Vidéos",
    _images: "Images",
    _audios: "Audio",
    _text: "Textes",
    _shapes: "Formes",
    _music: "Musique",
    _stock: "Stock",
    _myvideos: "Mes Vidéos",
    _myimages: "Mes Images",
    _mymusic: "Ma Musique",
    _categories: "Catégories",
    _animals: "Animaux",
    _cities: "Villes",
    _fantasy: "Fantaisie",
    _food: "Nourriture",
    _nature: "Nature",
    _space: "Espace",
    _sportsandhobbies: "Sports et Loisirs",
    _settings: "Paramètres",
    _language: "Langue",
    _uploadvideo: "Télécharger une Vidéo",
    _uploadimage: "Télécharger une Image",
    _uploadaudio: "Télécharger un Audio",
    _maxmbpervideo: "Maximum {mb} par vidéo",
    _maxmbperimage: "Maximum {mb} par image",
    _maxmbperaudio: "Maximum {mb} par audio",
    _addheading: "Ajouter un Titre",
    _addsubheading: "Ajouter un Sous-titre",
    _addbodytext: "Texte Principal",
    _select: "Sélectionner",
    _unselect: "Désélectionner",
    _animations: "Animations",
    _position: "Position",
    _copy: "Copier",
    _duplicate: "Dupliquer",
    _duration: "Durée",
    _textproperties: "Propriétés du Texte",
    _fill: "Remplissage",
    _stroke: "Contour",
    _textshadow: "Ombre du Texte",
    _offsetx: "Décalage X",
    _offsety: "Décalage Y",
    _blur: "Flou",
    _none: "Aucun",
    _small: "Petit",
    _medium: "Moyen",
    _large: "Grand",
    _fadein: "Fondu Entrant",
    _fadeout: "Fondu Sortant",
    _togglezoom: "Basculer le zoom",
    _paste: "Coller",
    _animationnone: "Aucune",
    _animationfadein: "Fondu",
    _animationzoom: "Zoom",
    _animationbounceinout: "Rebond",
    _animationslideleftright: "Glissement gauche-droite",
    _animationsliderightleft: "Glissement droite-gauche",
    _animationslideupdown: "Glissement haut-bas",
    _animationslidedownup: "Glissement bas-haut",
    _animationbouncehorizontal: "Rebond horizontal",
    _animationbouncevertical: "Rebond vertical",
    _animationsweepinchars: "Balayage caractères",
    _animationrollinoutchars: "Roulement caractères",
    _animationrisinginoutchars: "Élévation caractères",
    _animationdroppinginoutwords: "Chute mots",
    _animationfadeinoutlines: "Fondu lignes",
    _animationblurchars: "Flou caractères",
    _animationrolllines: "Défilement des Lignes",
    _exportingvideo: "Exportation de la vidéo",
    _queued: "En attente",
    _processing: "Traitement",
    _done: "Terminé",
    _failed: "Échoué",
    _newcompositionwarning: "En créant un nouveau projet, le projet actuel sera effacé. Êtes-vous sûr ?",
    _cancel: "Annuler",
    _ok: "OK",
    _lastexport: "Dernière Exportation",
    _downloadvideo: "Télécharger la Vidéo",
};
